var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoBookingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.0005,
    r: 40,
    fill: "#A0A0A0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6272 56H50.3772C51.9281 56 53.1897 54.7384 53.1897 53.1875V33.375H46.6272C45.0763 33.375 43.8147 32.1134 43.8147 30.5625V24H31.6272C30.0763 24 28.8147 25.2616 28.8147 26.8125V53.1875C28.8147 54.7384 30.0763 56 31.6272 56ZM35.3772 37.1875H46.6272C47.1454 37.1875 47.5647 37.6068 47.5647 38.125C47.5647 38.6432 47.1454 39.0625 46.6272 39.0625H35.3772C34.859 39.0625 34.4397 38.6432 34.4397 38.125C34.4397 37.6068 34.859 37.1875 35.3772 37.1875ZM35.3772 40.9375H46.6272C47.1454 40.9375 47.5647 41.3568 47.5647 41.875C47.5647 42.3932 47.1454 42.8125 46.6272 42.8125H35.3772C34.859 42.8125 34.4397 42.3932 34.4397 41.875C34.4397 41.3568 34.859 40.9375 35.3772 40.9375ZM35.3772 44.6875H46.6272C47.1454 44.6875 47.5647 45.1068 47.5647 45.625C47.5647 46.1432 47.1454 46.5625 46.6272 46.5625H35.3772C34.859 46.5625 34.4397 46.1432 34.4397 45.625C34.4397 45.1068 34.859 44.6875 35.3772 44.6875ZM35.3772 48.4375H42.8772C43.3954 48.4375 43.8147 48.8568 43.8147 49.375C43.8147 49.8932 43.3954 50.3125 42.8772 50.3125H35.3772C34.859 50.3125 34.4397 49.8932 34.4397 49.375C34.4397 48.8568 34.859 48.4375 35.3772 48.4375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6272 31.501H52.6404L45.6897 24.5503V30.5635C45.6897 31.0807 46.1099 31.501 46.6272 31.501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBookingIcon);
export default __webpack_public_path__ + "static/media/no-booking-icon.0896e7516406e244dd177db29d367e93.svg";
export { ForwardRef as ReactComponent };